<template lang="pug">
  div
    .title {{ title }}
    v-row
      v-col(
        v-for="item in items",
        :key="item.id",
        :sm="colSize",
      )
        v-checkbox(      
          dense,
          hide-details,  
          v-model="currentValue",
          :value="item.id",
          :label="stripInitialNumbers(item.name)",
          :error="$attrs['error-messages'] !== undefined",
        )
    .subtitle.error--text {{ $attrs['error-messages'] }}
</template>

<script>
import { stripInitialNumbers } from '@/utils/helper';

export default {
  props: {
    value: {
      type: Array,
      required: true,
    },

    items: {
      type: Array,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    colSize: {
      type: String,
      default: '4',
    },
  },

  computed: {
    currentValue: {
      get: function() {
        return this.value;
      },

      set: function(updatedValue) {
        this.$emit('update:value', updatedValue);
      },
    },
  },

  methods: {
    stripInitialNumbers,
  },
};
</script>
